import { useState, useEffect } from 'react'
import { Container, Grid, Box } from '@mui/material'

import FiscalYearDropdown from '../../common/FiscalYearDropdown/components/FiscalYearDropDown'
import SearchBar from './components/SearchBar'
import ExpensesTabs from './components/ExpensesTabs'
import ExpensesTable from './components/ExpensesTable/ExpensesTable'
import ExpensesTableHead from './components/ExpensesTable/ExpensesTableHead'
import ExpensesOverview from './components/ExpensesOverview'

import useExpensesSort from './hooks/useExpensesSort'

import ApiRGDD from './api/apiFiscalYears'

export const RGDD = ({ coproId }) => {
  const apiRGDD = new ApiRGDD()
  const [isLoading, setIsLoading] = useState(false)

  const [fiscalYears, setFiscalYears] = useState([])
  const [selectedFiscalYearId, setSelectedFiscalYearId] = useState(null)

  const [expenses, setExpenses] = useState([])

  const [selectedKey, setSelectedKey] = useState(null)
  const [search, setSearch] = useState('')

  // Handle sorting in another file
  const { sortedItems, handleSort, sortConfig, sortEcritures } =
    useExpensesSort(expenses)

  useEffect(() => {
    const fetchExpenses = async () => {
      if (
        selectedFiscalYearId == null ||
        selectedKey == 0 ||
        selectedKey == null
      ) {
        return
      }
      setIsLoading(true)

      const res = await apiRGDD.getExpenses(
        coproId,
        selectedFiscalYearId,
        selectedKey
      )
      setExpenses(res)
      setIsLoading(false)
    }
    fetchExpenses()
  }, [coproId, selectedFiscalYearId, selectedKey])

  useEffect(() => {
    const fetchFiscalYears = async () => {
      // Set first Key as default which is Overview, at start to show the interface
      setSelectedKey(0)

      setIsLoading(true) // Set loading state
      let res = await apiRGDD.getFiscalYears(coproId)
      // Delete Fiscal Years without Keys
      res = res.filter(
        (item) => !(Array.isArray(item.rgddKeys) && item.rgddKeys.length === 0)
      )

      setFiscalYears(res)

      // Set current year in FisclYears as default
      const currrentFiscalYear = res.filter((fy) => fy.status === 'current')[0]
      if (currrentFiscalYear) {
        setSelectedFiscalYearId(currrentFiscalYear && currrentFiscalYear.id)
      }

      setIsLoading(false) // Reset loading state
    }
    fetchFiscalYears()
  }, [])

  const handleFiscalYearChange = (fiscalYearId) => {
    setSelectedFiscalYearId(fiscalYearId)

    // Set Overview Tab by default
    setSelectedKey(0)
  }

  return (
    <Box>
      <Container disableGutters style={{ maxWidth: '100%' }}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ margin: '0px', paddingTop: '15px' }}
        >
          <Box
            sx={{
              flexGrow: 1,
              p: 3,
              maxWidth: { sm: '80%', margin: '0 auto' },
              overflow: 'auto',
            }}
            style={{
              position: 'fixed',
              zIndex: 2,
              top: '60px',
              backgroundColor: 'white',
              paddingBottom: '0px',
              minWidth: '80%',
              minHeight: '213px',
            }}
            container
            justifyContent="center"
            alignItems="center"
          >
            <Grid
              container
              item
              xs={12}
              alignItems="center"
              justifyContent="center"
              style={{ marginTop: '10px', marginBottom: '5px' }}
            >
              <Grid item xs={12} sm={6} md={3} sx={{ marginRight: '50px' }}>
                <FiscalYearDropdown
                  fiscalYears={fiscalYears}
                  selectedFiscalYearId={selectedFiscalYearId}
                  onFiscalYearDropDownChange={handleFiscalYearChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} alignItems="center">
                <SearchBar
                  onChangeSearchBar={setSearch}
                  disableSearchBar={selectedKey === 0}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sx={{ marginTop: '5px' }}>
              {fiscalYears.filter(
                (fy) => fy.id === selectedFiscalYearId
              )[0] && (
                <ExpensesTabs
                  expensesKeys={
                    fiscalYears.filter(
                      (fy) => fy.id === selectedFiscalYearId
                    )[0].rgddKeys
                  }
                  selectedKey={selectedKey}
                  onExpensesTabsChange={setSelectedKey}
                />
              )}
            </Grid>

            <ExpensesTableHead
              sortConfig={sortConfig}
              onExpensesTableHeadSort={handleSort}
              isGlobalView={selectedKey === 0}
            />
          </Box>

          <Grid
            item
            xs={12}
            sx={{
              width: '80%',
              position: 'absolute',
              top: '275px',
              overflowY: 'scroll',
              maxHeight: 'calc(100vh - 275px)',
              paddingBottom: '5px',
            }}
          >
            {isLoading ? (
              <div
                style={{
                  minHeight: '200px',
                  background: 'white',
                  fontSize: '24px',
                  justifyContent: 'center',
                  verticalAlign: 'middle',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Chargement des factures...
              </div>
            ) : selectedKey === 0 ? (
              <ExpensesOverview
                expensesKeys={
                  fiscalYears.filter((fy) => fy.id === selectedFiscalYearId)[0]
                    ?.rgddKeys
                }
                handleKeyClick={setSelectedKey}
              />
            ) : (
              <ExpensesTable
                expenses={expenses}
                search={search}
                sortEcritures={sortEcritures}
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}
